$(document).ready(() => {
    const elRates = document.querySelector(".srri__rates");
    if (elRates) {
        const rate = elRates.dataset.rate;
        document.querySelector(`#rate${rate}`).classList.add("active");
    }
});